class RiskFunction {
  public displayFixedRisk (risk: any): string {
    if (risk.is_risk === 1) {
      if (risk.harvest_risk_items.length === 0) {
        return 'あり'
      }
      let strArr = []
      for (const index in risk.harvest_risk_items) {
        strArr.push(risk.harvest_risk_items[index].harvest_risk_item_name)
      }
      return strArr.join(',')
    }
    return 'なし'
  }

  public displayOtherRisk (risk: any): string {
    if (risk.is_risk === 1) {
      if (risk.harvest_risks.length === 0) {
        return 'あり'
      }
      let strArr = []
      for (const index in risk.harvest_risks) {
        strArr.push(this.getHarvestRiskItem(risk.harvest_risks[index]))
      }
      return strArr.join(',')
    }
    return 'なし'
  }

  private getHarvestRiskItem (harvestRisk: any): string {
    let retStr = harvestRisk.harvest_risk_name
    if (harvestRisk.harvest_risk_items.length > 0) {
      let strArr = []
      for (const index in harvestRisk.harvest_risk_items) {
        strArr.push(harvestRisk.harvest_risk_items[index].harvest_risk_item_name)
      }
      retStr += '(' + strArr.join(',') + ')'
    }
    return retStr
  }
}

export default new RiskFunction()
